
import Footer from "./Footer";
import Navbar from "./Navbar";
import PaymentReceipt from "./PaymentReceipt";
const PaymentsuccessPage = () => {
    return (
        <>
            <Navbar />
            <PaymentReceipt />
            <Footer />
        </>
    )
}

export default PaymentsuccessPage